module.exports = __webpack_public_path__ + "img/vk.6538651a.svg";